/* src/app/calender/timetable/timetable.component.css */
.mock-test-wrapper {
  margin-top: 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px;
  background-color: white;
  font-family: "Arial", sans-serif;
}
.left {
  width: 50%;
}
.title {
  color: #f37021;
  font-size: 55px;
  font-weight: bold;
}
.subtitle {
  font-size: 32px;
  margin-top: 10px;
}
.modes {
  font-weight: bold;
  margin-top: 10px;
}
.highlight {
  margin-top: 20px;
  font-size: 24px;
  font-weight: bold;
}
.left p {
  font-size: 18px;
}
.highlight .orange {
  color: #f37021;
}
.calendar-btn {
  margin-top: 20px;
  padding: 12px 24px;
  background-color: #f37021;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
}
.right {
  width: 45%;
  display: flex;
  justify-content: center;
}
.target-image {
  width: 100%;
}
.marquee {
  background-color: black;
  color: white;
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
}
.cal-inst {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 50px;
}
.cal-inst h1 {
  font-weight: bold;
}
.cal-inst h2 {
  font-size: 24px;
}
.calendar-container {
  width: 90%;
  margin: auto;
  font-family: Arial, sans-serif;
  margin-top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  margin-top: 50px;
  margin-top: 50px;
}
.scrollable-container {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
}
.header,
.month-selector {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}
.month-selector {
  margin: 20px 0;
}
button {
  padding: 10px 16px;
  border: 2px solid #ccc;
  border-radius: 20px;
  background: white;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s;
}
.mode-buttons {
  height: 100px;
  display: flex;
  flex: 1;
  gap: 20px;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  border-radius: 20px 0px 0px 0px;
}
.type-buttons {
  height: 100px;
  display: flex;
  flex: 1;
  gap: 20px;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  border-radius: 0px 20px 0px 0px;
}
button.active {
  background-color: #ff7a00;
  color: white;
  border-color: #ff7a00;
}
.type-buttons button.active {
  background-color: #409eff;
  border-color: #409eff;
}
.test-group {
  margin-top: 30px;
  margin-left: 20px;
  margin-right: 20px;
  background-color: #f7f7f7;
  border-radius: 20px;
  overflow-x: visible;
}
.test-details {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #cbcbcb;
  border-radius: 20px 20px 0px 0px;
}
.test-details h4 {
  font-size: 22px;
  font-weight: bold;
}
.test-details p {
  margin: 0;
}
.test-list {
  display: flex;
  gap: 20px;
  margin: 20px;
  padding-bottom: 10px;
  overflow-x: auto;
}
.test-card {
  background: #f7f7f7;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;
  scroll-snap-align: start;
}
.test-card h5 {
  font-size: 18px;
  font-weight: 650;
  text-align: center;
}
.test-card p {
  font-size: 16px;
}
.test-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  align-items: center;
}
.test-card button {
  background-color: #ff7a00;
  color: white;
  border: none;
  border-radius: 30px;
}
.center-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
}
.center-options {
  display: flex;
  gap: 10px;
  margin: 20px 0;
  flex-wrap: wrap;
  justify-content: center;
}
.center-options button {
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 30px;
}
.close-btn {
  background-color: #999;
  color: white;
  margin-top: 10px;
}
.af-ts {
  display: flex;
  justify-content: center;
  align-items: center;
}
.af-ts h1 {
  text-align: center;
  margin-right: 25px;
  margin-left: 25px;
  margin-top: 80px;
}
.ft-sc {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  background-color: #fcfcfc;
  align-items: center;
  background-image: url(/assets/images/ft-bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  height: 100vh;
}
.ft-sc h1 {
  font-weight: 600;
  margin: 35px;
  color: rgb(30, 30, 30);
  font-size: 42px;
}
.ft-sc-info {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 20px;
}
.ft-sc-item {
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
  margin-bottom: 50px;
}
.ft-sc-item img {
  width: 75px;
}
.left {
  margin-left: 100px;
}
.right {
  margin-right: 100px;
}
.ft-sc-item h3 {
  color: #ed6823;
  font-size: 22px;
}
.ft-sc p {
  font-size: 18px;
}
.co-sc {
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  align-items: center;
}
.co-sc h1 {
  margin-top: 80px;
  text-align: center;
}
.co-sc h1 span {
  color: #f38d19;
  font-weight: bold;
}
.card-ts {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 22px;
  width: 380px;
  height: 250px;
  background-color: white;
  margin-top: 50px;
  margin-left: 25px;
  margin-right: 25px;
  margin-bottom: 50px;
  padding: 10px;
}
.ts-sc {
  display: flex;
}
.faq-sc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faq-sc h1 {
  margin-top: 50px;
  font-weight: bold;
  font-size: 42px;
}
.drop-d {
  width: 50%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #000000;
}
details {
  border: 0.5px solid #000000;
  overflow: hidden;
  width: 100%;
}
summary {
  padding: 10px 15px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  border-radius: 0;
  border: 0.5px solid #000000;
  list-style: none;
  font-size: 16px;
}
details[open] summary {
  background: #e0e0e0;
}
details div {
  padding: 15px;
  background: #fff;
}
summary::before {
  content: "\25bc    ";
  font-size: 14px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}
details[open] summary::after {
  transform: rotate(180deg);
}
details div {
  padding: 0 15px;
  background: #fff;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  transition:
    transform 0.4s ease-in-out,
    opacity 0.3s ease-in-out,
    height 0.4s ease-in-out;
}
details[open] div {
  opacity: 1;
  height: auto;
  transform: scaleY(1);
  padding: 15px;
}
a {
  color: red;
  text-decoration: none;
}
.so-sc {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 25px;
}
.so-sc img {
  width: 30px;
  height: 30px;
}
@media (max-width: 768px) {
  .mock-test-wrapper {
    flex-direction: column;
    margin-top: 80px;
    padding: 20px;
  }
  .left,
  .right {
    width: 100%;
  }
  .left {
    text-align: center;
    margin-bottom: 30px;
  }
  .title {
    font-size: 40px;
    line-height: 1.2;
  }
  .subtitle {
    font-size: 24px;
    margin-top: 8px;
  }
  .modes {
    font-size: 16px;
    margin-top: 8px;
  }
  .highlight {
    font-size: 20px;
    margin-top: 15px;
  }
  .left p {
    font-size: 16px;
  }
  .calendar-btn {
    padding: 10px 20px;
    font-size: 14px;
  }
  .target-image {
    width: 80%;
    max-width: 300px;
  }
  .right {
    margin-top: 20px;
    justify-content: center;
  }
  .logo3 {
    width: 100px;
    height: 50px;
  }
  .top p {
    font-size: 12px;
  }
  .nw-strp {
    gap: 10px;
    padding: 5px;
  }
  .nw-strp h5 {
    font-size: 11px;
  }
  .nw-strp-lft {
    gap: 5px;
  }
  .nw-strp-rgt {
    gap: 5px;
  }
  .bk-dm {
    padding: 5px;
    font-size: 10px;
  }
  .to-nmt {
    font-size: 10px;
    padding: 5px;
  }
  .trust-pilot img {
    width: 100px;
    height: 50px;
  }
  .hs-h1 {
    font-size: 30px;
  }
  .hs-h2 {
    font-size: 24px;
    text-align: center;
  }
  .hero-section h2 {
    text-align: center;
    font-size: 18px;
    margin-left: 10px;
    margin-right: 10px;
    line-height: 20px;
  }
  .hero-section h3 {
    font-size: 18px;
    text-align: center;
  }
  .hero-section h4 {
    font-size: 16px;
  }
  .hs-btns {
    flex-direction: column;
  }
  .hero-section ul {
    flex-direction: column;
  }
  .stripe h3 {
    font-size: 20px;
    text-align: center;
  }
  .af-ts h1 {
    font-size: 24px;
  }
  .ft-sc h1 {
    text-align: center;
    font-size: 24px !important;
  }
  .left {
    margin-left: 00px;
  }
  .right {
    margin-right: 00px;
  }
  .container {
    padding: 10px;
    height: auto;
  }
  .header2 h1 {
    font-size: 18px;
    padding-left: 10px;
  }
  .header2 h2 {
    font-size: 14px;
    display: none;
  }
  .logo-mocktest {
    width: 80px;
    height: 30px;
  }
  .tabs {
    gap: 5px;
    flex-wrap: wrap;
  }
  .tab {
    padding: 8px 12px;
    font-size: 14px;
  }
  .timetable {
    margin-top: 10px;
  }
  .test-row {
    height: auto;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
  }
  .test-info.enhanced {
    height: auto;
    flex: none;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
  }
  .test-date {
    width: auto;
    font-size: 16px;
    margin-top: 10px;
  }
  .testName {
    font-size: 16px;
  }
  .btn-tab {
    font-size: 14px;
    text-align: center;
  }
  .cal-inst h1 {
    font-weight: bold;
    font-size: 28px;
    text-align: center;
  }
  .cal-inst h2 {
    font-size: 18px;
    text-align: center;
  }
  .test-centers {
    flex-direction: column;
    gap: 10px;
    margin: 10px 0;
  }
  .center {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
  }
  .book-btn {
    display: block;
    margin-top: 10px;
  }
  .ft-sc-info {
    flex-direction: column;
    align-items: center;
  }
  .ft-sc {
    height: 100%;
  }
  .ft-sc h1 {
    text-align: center;
    font-size: 24px !important;
  }
  .ft-sc-item {
    width: 250px;
    height: 200px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .ft-sc-item img {
    margin: 5px;
    width: 45px;
  }
  .ft-sc-item h3 {
    font-size: 18px;
    line-height: 20px;
  }
  .ft-sc p {
    font-size: 14px;
  }
  .co-sc h1 {
    margin-top: 25px;
    font-size: 22px;
  }
  .ts-sc {
    flex-direction: column;
  }
  .card-ts {
    width: 300px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-ts h4 {
    font-size: 16px;
  }
  .card-ts p {
    font-size: 12px;
  }
  .faq-sc h1 {
    margin-top: 25px;
    font-size: 36px;
  }
  .drop-d {
    width: 90%;
  }
  .faq-sc h3 {
    font-size: 18px;
    line-height: 25px;
  }
  .calendar-container {
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }
  .header {
    flex-direction: column;
    gap: 0;
  }
  .mode-buttons,
  .type-buttons {
    height: auto;
    padding: 15px 10px;
    border-radius: 0 !important;
    flex-wrap: wrap;
  }
  button {
    padding: 8px 12px;
    font-size: 14px;
  }
  .month-selector {
    margin: 10px 0;
    padding: 0 10px;
    justify-content: center;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .test-group {
    margin-left: 10px;
    margin-right: 10px;
  }
  .test-details {
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
  }
  .test-details h4 {
    font-size: 18px;
  }
  .test-details p {
    font-size: 14px;
  }
  .test-list {
    margin: 10px;
    flex-direction: column;
  }
  .test-card {
    width: 100%;
    padding: 12px;
  }
  .test-card h5 {
    font-size: 16px;
  }
  .test-card p {
    font-size: 14px;
  }
  .popup-content {
    width: 90%;
    padding: 20px 15px;
  }
  .popup-content h3 {
    font-size: 18px;
  }
  .center-options {
    flex-direction: column;
    width: 100%;
  }
  .center-options button {
    width: 100%;
  }
}
/*# sourceMappingURL=timetable.component.css.map */
